/* eslint-disable */
import React, { FC, ReactElement, useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom';
import withLocalization from '../../components/hoc/withLocalization';
import OfferHeader from '../../components/common/OfferHeader/OfferHeader';
import ParseHtml from '../../components/common/ParseHtml';
import { resetPinOptFlowDetails } from '../OfferValidateContainer/PinOptFlowOfferSlice';
import { resetPaymentData, clearPaymentPage } from '../OfferPaymentContainer/OfferPaymentSlice';
//import { useMediaQuery } from 'react-responsive';
import { resetProspectDetails, resetOfferSearch, resetShowCTA } from '../offerSearch/offerSearchSlice';
import phoneLogo from '../../features/siteTheme/Brands/tmvcs/logo/intl-phoneLogo.svg';
import { OFFER_EXPIRED } from '../../util/errorString';
import isAsia from '../../util/isAsia';
import './PinOptFlowError.scss';
import { getSafeTelHref } from '../../util/CommonLogic';

const PinOptFlowError: FC<any> = (props: any): ReactElement => {
  const { localize, localizeImages, errPhone } = props;
  const location = useLocation();
  const dispatch = useDispatch();
  const [headPhone, setHeadPhone] = useState('');
  const [chatLink, setChatLink] = useState('');
  //const isMobile = useMediaQuery({ query: `(max-width: 500px)` });
  const stateData: any = location?.state || {};
  const stateNo = stateData?.errPhNo || '';
  const errorCode = stateData?.errorCode || '';
  const isPackageSold = stateData?.isPkgSold;
  const callCenterCode = stateData?.callCenterCode || '';
  const isOfferExpired = errorCode?.toLocaleUpperCase() === OFFER_EXPIRED;
  const { path } = localizeImages('preview-sales-engine.static-content.images.not-my-info-hero', 0, '7:3');
  //const mobPath = localizeImages('preview-sales-engine.static-content.images.not-my-info-hero', 0, '7:3');
  const whatsAppImgData = props.localizeImages('preview-sales-engine.static-content.images.whatsapp-logo', 0, '5:1');
  const whatsAppPath = whatsAppImgData?.path || '';
  const styleBg = {
    backgroundImage: `url("${path}")`,
  };
  const phNo = isAsia
    ? localize('preview-sales-engine.static-content.copy.pbeo.intl.asia-default-phone-number')
    : localize('preview-sales-engine.static-content.copy.pbeo.intl.me-default-phone-number');
  const defaultChatLinkText = isAsia
    ? localize('preview-sales-engine.static-content.copy.pbeo.intl.asia-default-chat-link')
    : localize('preview-sales-engine.static-content.copy.pbeo.intl.me-default-chat-link');
  const defaultLink = defaultChatLinkText || '';
  const LogoPath = props.localizeImages('preview-sales-engine.static-content.images.mvc-logo', 0, '5:1');
  const jahiaKey = `preview-sales-engine.static-content.copy.pbeo.intl.call-centers.${callCenterCode}.chat-link`;

  const jahiaActivation = `preview-sales-engine.static-content.copy.pbeo.intl.call-centers.${callCenterCode}.activationPhone`;

  const activationPhone = `${localize(jahiaActivation)}`;
  const defaultActivePhone = activationPhone || phNo;

  const jahiaCallcenter = `preview-sales-engine.static-content.copy.pbeo.intl.call-centers.${callCenterCode}.errorPhone`;
  const callCenterDefault = `${localize(jahiaCallcenter)}`;

  //const callCentNo = stateNo || callCenterDefault;
  const callCentNo = callCenterDefault || phNo;
  const defaultPhoneNo = callCentNo || phNo;

  const offerExpiredMessage = localize('preview-sales-engine.static-content.copy.pbeo.intl.offerexpiredspecialist');
  const packageSoldMessage = localize('preview-sales-engine.static-content.copy.pbeo.intl.alreadypurchasespecialist');
  const defaultContent = localize('preview-sales-engine.static-content.copy.pbeo.intl.intl-not-my-info-description');
  const contentDesc = isOfferExpired ? offerExpiredMessage : isPackageSold ? packageSoldMessage : defaultContent;
  const pageTitle = isPackageSold
    ? localize('preview-sales-engine.static-content.copy.prospects.greatnewstext')
    : localize('preview-sales-engine.static-content.copy.pbeo.not-my-info-header');
  useEffect(() => {
    const headerPhone = isOfferExpired ? callCentNo : isPackageSold ? defaultActivePhone : defaultPhoneNo;
    const chatLinkText: any = localize(jahiaKey) || defaultLink;
    setHeadPhone(headerPhone);
    setChatLink(chatLinkText);
  }, []);
  useEffect(() => {
    window.scrollTo(0, 0);
    dispatch(resetOfferSearch());
    dispatch(resetPinOptFlowDetails());
    dispatch(resetProspectDetails());
    dispatch(resetShowCTA(false));
    dispatch(resetPaymentData());
    dispatch(clearPaymentPage());
    sessionStorage.clear();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const handleClick = () => {
    window.location.href = getSafeTelHref(headPhone);
  };
  const handleKeyDown = () => {};
  const handleClickChatLink = (e: any) => {
    e.preventDefault();
    //window.location.href = chatLinkText;
    window.open(chatLink, '_blank');
    window.dataLayer.push({
      event: 'whatsapp',
    });
  };

  return (
    <>
      <OfferHeader phone={headPhone} isThankyou={false} chatLink={chatLink} />
      <div className="pinFlowOpt-err-Main-container">
        {/*<img src={path} alt="error" className="pinFlowErrImg" />*/}
        <div className="pin-err-img-wrapper">
          <div className="image-pin-err-container" style={styleBg}></div>
        </div>
        <div className="pinOpt-err-container">
          <div className="pinOpt-err-inner-container">
            <span className="pinOpt-err-head-wrapper">{pageTitle}</span>
            <div className="pinOpt-err-textGroup">
              <>
                <div className="pinOpt-err-desc">
                  <ParseHtml htmlInput={contentDesc}></ParseHtml>
                </div>
                <div className="pinOpt-err-phone-container">
                  <div className="pinOpt-err-phone-link">
                    <a className="pinOpt-err-phone-anchor" href={encodeURI(getSafeTelHref(headPhone))}>
                      <img
                        onKeyDown={handleKeyDown}
                        tabIndex={0}
                        //onClick={handleClick}
                        src={phoneLogo}
                        alt="Call Now"
                        className="pinOpt-err-phone-icon"
                      />
                      <span
                        aria-label={'phone-err-call'}
                        onKeyDown={handleKeyDown}
                        tabIndex={0}
                        // onClick={handleClick}
                        className="pinOpt-err-phone"
                      >{`+${headPhone}`}</span>
                    </a>
                    {chatLink && (
                      <>
                        <div className="header-pipe">|</div>
                        <a href={'#'} onClick={handleClickChatLink}>
                          <img className="desk-phone-img" src={whatsAppPath} alt="whatsapp" />
                        </a>
                      </>
                    )}
                  </div>
                </div>
              </>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default withLocalization(PinOptFlowError);
